import React from 'react';
import { createPortal } from 'react-dom';

// Confirmation before something that cannot be undone (submitting an evaluation step). Rendered into document.body: the
// screens sit inside an animated (transformed) container, which would otherwise become the containing block of this
// fixed overlay and put the dialog far from the viewport.
export default function EsgConfirmDialog({ title, children, confirmLabel, busy, onConfirm, onCancel }) {
  return createPortal(
    <div className="modal-overlay" onClick={busy ? undefined : onCancel}>
      <div
        className="modal-card esg-confirm-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="esg-confirm-dialog-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="esg-confirm-icon" aria-hidden="true">!</div>
        <h3 id="esg-confirm-dialog-title">{title}</h3>
        <div className="esg-confirm-text">{children}</div>
        <div className="esg-confirm-actions">
          <button type="button" className="esg-btn esg-btn-secondary" disabled={busy} onClick={onCancel}>Cancel</button>
          <button type="button" className="esg-btn esg-btn-primary" disabled={busy} onClick={onConfirm} autoFocus>
            {busy ? 'Submitting...' : confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
